import { ArrowRight } from "lucide-react";
import chatGptMarkWhite from "../assets/platform/chatgpt-mark-white.svg";

type ChatGptCtaProps = {
  className: string;
  label: string;
};

function readConfiguredUrl(): string | null {
  const value = (import.meta.env.VITE_HEPAPAL_CHATGPT_URL ?? "").trim();
  if (!value) return null;

  try {
    const url = new URL(value);
    return url.protocol === "https:" ? url.toString() : null;
  } catch {
    return null;
  }
}

const chatGptUrl = readConfiguredUrl();

function CtaContents({ label, pending }: ChatGptCtaProps & { pending: boolean }) {
  return (
    <>
      <img className="chatgpt-cta-logo" src={chatGptMarkWhite} alt="" aria-hidden="true" />
      <span className="chatgpt-cta-copy button-label">
        <span>{label}</span>
        {pending ? <small className="chatgpt-cta-status">Coming soon</small> : null}
      </span>
      <ArrowRight aria-hidden="true" />
    </>
  );
}

export function ChatGptCta({ className, label }: ChatGptCtaProps) {
  const classes = `${className} chatgpt-cta${chatGptUrl ? "" : " chatgpt-cta-pending"}`;

  if (!chatGptUrl) {
    return (
      <button
        className={classes}
        type="button"
        disabled
        aria-label={`${label}. Coming soon.`}
      >
        <CtaContents className={className} label={label} pending />
      </button>
    );
  }

  return (
    <a className={classes} href={chatGptUrl} target="_blank" rel="noopener noreferrer">
      <CtaContents className={className} label={label} pending={false} />
    </a>
  );
}
